import LoginBanner from "components/shared/LoginBanner";
import { useSelector } from "react-redux";
import { authActions } from "../../../redux/slice/auth.slice";
import Authenticate from "../Login/designs/Authenticate";
import SignUpForm from "./designs/SignUpForm";

const SignUp = () => {
  const signUpTab = useSelector(authActions.selectors.getSignUpTab);
  
  const rendered = (val) => {
    switch (val) {
      case 0:
        return <SignUpForm  />;
      case 1:
        return <Authenticate />;
      default:
        return <SignUpForm />;
    }
  }
  return (
    <div className="grid grid-cols-1 bg-[#F2F2F2]  md:grid-cols-2">
      {rendered(signUpTab)}
      <LoginBanner />
    </div>
  );
};

export default SignUp;
